module.exports = __webpack_public_path__ + "img/back.3daebe23.png";